import * as Sentry from '@sentry/vue';
import { useRuntimeConfig } from "@/composables/useRuntimeConfig";

const { APP_ENV } = useRuntimeConfig();

export function setupSentry(app, router) {
  if (APP_ENV === 'local') return;

  Sentry.init({
    app,
    dsn: import.meta.env.VITE_SENTRY_DSN,
    environment: APP_ENV,
    integrations: [
      Sentry.browserTracingIntegration({ router }),
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false,
      }),
    ],
    tracesSampleRate: 1.0,
    tracePropagationTargets: [import.meta.env.VITE_SENTRY_TARGET_URL],
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  });
}
